import { render, staticRenderFns } from "./DesignFormItem.vue?vue&type=template&id=27bcf4aa&scoped=true&"
import script from "./DesignFormItem.vue?vue&type=script&lang=js&"
export * from "./DesignFormItem.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormItem.vue?vue&type=style&index=0&id=27bcf4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bcf4aa",
  null
  
)

export default component.exports